export const cardTypes = {
  PAYME: 'payme',
  UZCARD: 'uzcard',
}
